// extracted by mini-css-extract-plugin
module.exports =  {"userDetailGridBackground":"UserDetailsComponent_userDetailGridBackground__Y094e"};